import { render, staticRenderFns } from "./StateFeeRequirementSummary.vue?vue&type=template&id=656f55e9"
import script from "./StateFeeRequirementSummary.vue?vue&type=script&lang=ts"
export * from "./StateFeeRequirementSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports